import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
const TITLE = "Calculez la valeur de l'or avec facilité et précision - Convertisseur de carats d'or";
const DESCRIPTION =
  "Calculez la valeur de l pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "la valeur de l, calculatrice la valeur de l, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gold-karat/";
function GoldKaratCalculator() {
  const [goldWeight, setGoldWeight] = useState(1.0);
  const [goldKarat, setGoldKarat] = useState(24);
  const [conversionResults, setConversionResults] = useState(null);
  const [error, setError] = useState(null);
  const handleGoldWeightChange = (event) => {
    setGoldWeight(event.target.value);
  };
  const handleGoldKaratChange = (event) => {
    setGoldKarat(event.target.value);
  };
  const calculateGoldKarat = () => {
    // Validate inputs
    const weight = parseFloat(goldWeight);
    const karat = parseFloat(goldKarat);
    if (isNaN(weight) || weight <= 0) {
      setError("Veuillez entrer un poids correct supérieur à zéro");
      setConversionResults(null);
      return;
    }
    if (isNaN(karat) || karat <= 0 || karat > 24) {
      setError("Veuillez entrer un carat correct entre 1 et 24");
      setConversionResults(null);
      return;
    }
    try {
      // Calculate pure gold weight from original karat
      const pureGoldWeight = weight * (karat / 24);
      // Convert to each target karat
      const results = {};
      const targetKarats = [24, 22, 21, 18, 14, 10];
      targetKarats.forEach(targetKarat => {
        // Formula: convertedWeight = pureGoldWeight / (targetKarat / 24)
        // Which simplifies to: pureGoldWeight * (24 / targetKarat)
        const convertedWeight = pureGoldWeight * (24 / targetKarat);
        results[`karat_${targetKarat}`] = convertedWeight.toFixed(4);
      });
      setConversionResults(results);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Une erreur inattendue s'est produite. Veuillez réessayer.");
      setConversionResults(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <b> Calculatrice de conversion de carat d'or vers différents carats </b>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Cette calculatrice calcule le poids de l'or dans différents carats selon le poids d'or original et le carat spécifié<br />
                Cette calculatrice vise à convertir le poids de l'or d'un carat à un autre
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col calculatorStyle" style={{ minWidth: "300px" }}>
                <div className="p-3 mb-2 bg-success text-white">
                  Calculatrice de conversion de carat d'or vers différents carats
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="goldWeight" className="form-label ms-2">
                    Poids d'or original:
                  </label>
                  <input
                    type="number"
                    id="goldWeight"
                    value={goldWeight}
                    onChange={handleGoldWeightChange}
                    className="form-control"
                    style={{ width: "100%", marginLeft: "10px" }}
                    placeholder="Exemple: 27.7"
                    step="0.01"
                    min="0"
                  />
                  <label htmlFor="goldKarat" className="form-label ms-2">
                    Carat d'or d'origine:
                  </label>
                  <select
                    id="goldKarat"
                    style={{ width: "90%" }}
                    className="form-select"
                    value={goldKarat}
                    onChange={handleGoldKaratChange}
                  >
                    <option value="24">24</option>
                    <option value="22">22</option>
                    <option value="21">21</option>
                    <option value="18">18</option>
                    <option value="14">14</option>
                    <option value="10">10</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateGoldKarat}
                >
                  Calculer
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {error && (
                  <div className="alert alert-danger">
                    <b>
                      <u> Erreur :</u>
                    </b>{" "}
                    {error}{" "}
                  </div>
                )}
                {conversionResults && (
                  <div className="mt-4 p-3 alert alert-success">
                    <h3>Résultats:</h3>
                    <p>
                      Si vous avez <b>{goldWeight}</b> grammes d'or carat{" "}
                      <b>{goldKarat}</b>, cette valeur d'or est équivalente à:
                    </p>
                    <ul className="list-group">
                      {Object.entries(conversionResults).map(
                        ([karatKey, weight]) => (
                          <li key={karatKey} className="list-group-item">
                            {parseFloat(weight).toFixed(2)} grammes d'or carat{" "}
                            {karatKey.replace("karat_", "")}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Description du convertisseur de carat d'or vers différents carats:
              </div>
              <div className="info-section-body">
                <u>
                  <b> Convertir le carat d'or vers différents carats: </b>{" "}
                </u>{" "}
                <br/>
                Cette calculatrice convertit le poids de l'or d'un carat à différents carats. La calculatrice reçoit le poids de l'or et le carat d'origine comme entrées. La calculatrice s'assure que les entrées reçues sont correctes, de sorte que le poids et le carat doivent être supérieurs à zéro et que le carat d'origine ne dépasse pas 24 carats (or pur).
                <br />
                Sur la base du poids et du carat d'origine, la calculatrice calcule le poids équivalent de l'or dans chaque carat des carats pris en charge (24, 22, 21, 18, 14, 10). La teneur en or pur est d'abord calculée, puis convertie en différents carats.
                <br/>
                À la fin du calcul, les poids calculés pour chaque carat sont affichés avec précision.
                <br/>
                Cette calculatrice facilite le processus de conversion du poids de l'or entre différents carats facilement et précisément, même si vous n'avez pas de connaissances spécialisées dans ce domaine.
                <br />
                <hr />
                <div className="alert alert-info">
                  <b>Exemple illustratif:</b>
                  <br />
                  Si vous avez 27.7 grammes d'or carat 22:
                  <ul>
                    <li>Contenu d'or pur = 27.7 × (22/24) = 25.39 grammes</li>
                    <li>Conversion en carat 24 = 25.39 grammes (moins que le poids d'origine)</li>
                    <li>Conversion en carat 18 = 25.39 × (24/18) = 33.85 grammes (plus que le poids d'origine)</li>
                  </ul>
                  <b>Règle importante:</b> En convertissant en un carat supérieur, le poids diminue. En convertissant en un carat inférieur, le poids augmente.
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GoldKaratCalculator;
